import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentResult({ cancel }) {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { clear } = useCart();
  const rzpTx = params.get("tx");
  const [status] = useState(cancel ? "cancel" : rzpTx ? "paid" : "cancel");

  useEffect(() => {
    // Razorpay path: verify already ran on Cart/ProductDetail before nav here.
    if (rzpTx) clear();
  }, [rzpTx]);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      {status === "paid" && (
        <>
          <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-500" />
          <h1 className="font-display font-bold text-2xl mt-6">Purchase complete!</h1>
          <p className="text-muted-foreground mt-2">Your CAD file is ready to download from your dashboard.</p>
          <button data-testid="go-downloads-btn" onClick={() => nav("/buyer")} className="mt-6 bg-primary text-primary-foreground rounded-md px-6 py-3 font-semibold hover:bg-primary/90">
            Go to my downloads
          </button>
        </>
      )}
      {status === "cancel" && (
        <>
          <XCircle className="h-14 w-14 mx-auto text-red-500" />
          <h1 className="font-display font-bold text-2xl mt-6">Payment cancelled</h1>
          <p className="text-muted-foreground mt-2">No charge was made. You can try again anytime.</p>
          <Link to="/marketplace" className="inline-block mt-6 border border-border rounded-md px-6 py-3 font-semibold hover:border-primary">
            Back to marketplace
          </Link>
        </>
      )}
    </div>
  );
}
